import { Theme } from '@mui/material'

import makeStyles from '@mui/styles/makeStyles'

type StylesType = {
  depth: number
}

const useStyles = makeStyles<Theme, StylesType>(theme => ({
  spacer: {
    paddingLeft: ({ depth }) => `${depth * 10}px`
  },

  loading: {
    margin: '5px',
    width: '20px',
    height: '20px'
  }
}))

export default useStyles
